export const deleteItem = "CtVN4";
export default {deleteItem};